import { absolutePath } from "../../absolutePath";

export const connectSettings = {
  update: () => absolutePath(`admin/connect/settings`),
};
